var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSearchLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_6397_11268)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.5474 18.0762L15.9585 14.4873C17.0669 13.0518 17.7424 11.2679 17.7424 9.31511C17.7424 4.67067 13.953 0.881226 9.29796 0.881226C4.64296 0.881226 0.853516 4.67067 0.853516 9.32567C0.853516 13.9807 4.64296 17.7701 9.29796 17.7701C11.2507 17.7701 13.0346 17.1051 14.4702 15.9862L18.0591 19.5751C18.2702 19.7862 18.5341 19.8812 18.8085 19.8812C19.083 19.8812 19.3468 19.7757 19.558 19.5751C19.9696 19.1634 19.9696 18.4984 19.558 18.0868L19.5474 18.0762ZM2.96463 9.32567C2.96463 5.83178 5.80407 2.99234 9.29796 2.99234C12.7918 2.99234 15.6313 5.83178 15.6313 9.32567C15.6313 12.8196 12.7918 15.659 9.29796 15.659C5.80407 15.659 2.96463 12.8196 2.96463 9.32567Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_6397_11268"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 19,
  transform: "translate(0.853516 0.881226)"
})))));
export default SvgIconSearchLg;